export const FETCH_MERCHANTS = "MERCHANT/FETCH_MERCHANTS";
export const FETCH_MERCHANTS_SUCCESS = "MERCHANT/FETCH_MERCHANTS_SUCCESS";
export const FETCH_MERCHANTS_FAILURE = "MERCHANT/FETCH_MERCHANTS_FAILURE";
